import { Button, Card, CardContent, Grid, Typography, IconButton, CardActions } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import eye from '_assets/register/eye.svg';
import eye_greyed from '_assets/register/eye-greyed.svg';
import cancel from '_assets/parameters/cancel.svg';
import circleOk from '_assets/parameters/circleOk.svg';
import download from '_assets/parameters/download.svg';

const useStyles = makeStyles((theme) => ({
  card: {
    width: '150px',
    height: '150px',
    backgroundColor: theme.palette.blue.lightest,
    padding:0,
  },
  inputContainer: {
    display:'flex',
    justifyContent:'space-around'
  },
  input: {
    display: 'none',
  },
  title: {
    fontFamily: 'CenturyGothic',
    fontWeight: 400,
    fontSize: 18,
    lineHeight: '22.07px',
    textAlign: 'center',
    paddingTop:'10%'
  },
  checkmark: {
    display:'flex',
    justifyContent:'flex-end',
    height:'100%',
    padding:'3%'
  },
  image: {
    display:'flex',
    justifyContent:'center',
    paddingLeft:'20%',
    paddingTop:'5%'
  },

  button: {
    color: theme.palette.text.title,
    minWidth:0,
  },
}));

const DocumentCard = ({ disabled, document, logo, name, onChange }) => {
  const classes = useStyles();

  const handleOpenClick = () => {
    if (document?.url) window.open(document.url);
  }

  const handleChange = async (event) => {
    if (event.target.files != null && event.target.files.length > 0) {
      const file = event.currentTarget.files[0];
      const blob = new Blob(
        [file],
        { type: 'application/pdf' }
      );
      const fileURL = URL.createObjectURL(blob);
      onChange(file, fileURL);
    }
  }

  const handleClick = (event) => {
    event.target.value = '';
  }

  return (
    <Card className={classes.card} >
      <CardContent style={{padding:0, paddingBottom:0}}>
        <Typography color='primary'>
          <Grid container >
            <Grid item xs={10} className={classes.image}>
              <img src={logo} alt='Logo' width={40} height={40} />
            </Grid>
            <Grid item xs={2} className={classes.checkmark} style={document?.url? {} : { padding:0 }}>
              <img
                  alt='Arrow right'
                  style={{ marginLeft: '1em' }}
                  src={document?.url ? circleOk : cancel}
                  width={document?.url ? 20 : 30}
                  height={document?.url ? 20 : 30}
              />
            </Grid>
          </Grid>
          <Grid>
            <div className={classes.title}>{name}</div>
          </Grid>
        </Typography>
      </CardContent>
      <Grid>
        <CardActions className={classes.inputContainer}>
          <input
              className={classes.input}
              disabled={disabled}
              accept='application/pdf'
              id={name}
              name={name}
              type='file'
              onChange={handleChange}
              onClick={handleClick}
          />
        <label htmlFor={name}>
          <IconButton color='primary' aria-label='upload picture' component='span' size='small' disabled={disabled}>
            <img src={download} alt='upload document' width={30} height={30}/>
          </IconButton>
        </label>
          <Button className={classes.button} enabled={!!document?.url} size="small" onClick={handleOpenClick}>
            <img src={document?.url ? eye: eye_greyed} alt='préview document' width={30} height={30}/>
          </Button>
        </CardActions>
      </Grid>
    </Card>
  );
};

export default DocumentCard;
